import type { FC, SVGProps } from 'react';

export const CalendarIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="20"
    height="20"
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.2146 2.68136H14.4646V1.25279C14.4646 1.15458 14.3843 1.07422 14.2861 1.07422H13.0361C12.9378 1.07422 12.8575 1.15458 12.8575 1.25279V2.68136H7.14321V1.25279C7.14321 1.15458 7.06285 1.07422 6.96463 1.07422H5.71463C5.61642 1.07422 5.53606 1.15458 5.53606 1.25279V2.68136H1.78606C1.39097 2.68136 1.07178 3.00056 1.07178 3.39565V18.2171C1.07178 18.6122 1.39097 18.9314 1.78606 18.9314H18.2146C18.6097 18.9314 18.9289 18.6122 18.9289 18.2171V3.39565C18.9289 3.00056 18.6097 2.68136 18.2146 2.68136ZM17.3218 17.3242H2.67892V8.84208H17.3218V17.3242ZM2.67892 7.32422V4.2885H5.53606V5.35993C5.53606 5.45815 5.61642 5.53851 5.71463 5.53851H6.96463C7.06285 5.53851 7.14321 5.45815 7.14321 5.35993V4.2885H12.8575V5.35993C12.8575 5.45815 12.9378 5.53851 13.0361 5.53851H14.2861C14.3843 5.53851 14.4646 5.45815 14.4646 5.35993V4.2885H17.3218V7.32422H2.67892Z"
    />
  </svg>
);
